module.exports = __webpack_public_path__ + "media/images/front/home/cards/card_5-74f50e9c8cdb7fbe33c84149acd5a43b.jpg";